import { loadMessages } from '@progress/kendo-react-intl'

export const loadForLocale = async (locale: any) => {
  const messages = await import(`./${locale}.json`)
  loadMessages(messages.default, locale)
  return messages
}
